import { render, staticRenderFns } from "./CloseEditionModal.vue?vue&type=template&id=d6e2b466&"
import script from "./CloseEditionModal.vue?vue&type=script&lang=ts&"
export * from "./CloseEditionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports